module.exports = __webpack_public_path__ + "img/theoriq.40fc3ecc.svg";